import { map, take, isEmpty, get } from 'lodash';
import numeral from 'numeral';
import { extractValue } from './shared';

const MAX_FAVORITES_COUNT = 10;

const RELEASED_STATUS = 'Released';

export const isReleased = status => status === RELEASED_STATUS;

export const formatEmotionData = ({ data = [], fields = {}, loading } = {}) => {
  if (isEmpty(data)) {
    return [];
  }

  return {
    data: data.map(d => ({
      emotionCount: d[fields.emotionCount],
      emotionName: d[fields.emotionName],
      emotionPercent: d[fields.emotionPercent]
    })),
    loading
  };
};

export const getEmotionVotes = ({ data = [], fields = {} } = {}) => {
  if (isEmpty(data)) {
    return null;
  }

  const minSampleSize = 50;
  const sampleCount = get(data, [0, fields.sampleCount], 0);
  const totalVotesCount = get(data, [0, fields.totalVotesCount], 0);

  if (sampleCount < minSampleSize) {
    return null;
  }

  return `n= ${numeral(sampleCount).format('0,0')} | Total Votes ${numeral(
    totalVotesCount
  ).format('0,0')}`;
};

export const formatMovie = movie => {
  return !movie
    ? {}
    : {
        uuid: movie['pdt_movie_detail.movie_uuid'] || '',
        releaseDate: movie['pdt_movie_detail.first_release_date'] || '',
        language: movie['pdt_movie_detail.original_language'] || '',
        overview: movie['pdt_movie_detail.description'] || '',
        name: movie['pdt_movie_detail.movie_name'] || '',
        tagline: '',
        runtime: movie['pdt_movie_detail.movie_runtime_type'] || '',
        genres: movie['pdt_movie_detail.genre'] || '',
        artwork_background: movie['pdt_movie_detail.poster_image_url'] || '',
        artwork_poster: movie['pdt_movie_detail.poster_image_url'] || '',
        status: movie['pdt_movie_detail.status'] || '',
        studio: movie['pdt_movie_detail.studio_name'] || '',
        follower_count: 0
      };
};

export const getCurrentTabFromPath = (history, config, contentId) => {
  const paths = history.location.pathname.split('/');
  const lastPath = paths[paths.length - 1];

  if (lastPath === contentId || lastPath === 'anticipation') {
    return config.MOVIE_ANTICIPATION_PAGE_ID;
  } else if (lastPath === 'audience') {
    return config.MOVIE_VIEWERSHIP_PAGE_ID;
  } else if (lastPath === 'engagement') {
    return config.MOVIE_ENGAGEMENT_PAGE_ID;
  } else if (lastPath === 'affinity') {
    return config.MOVIE_AFFINITY_PAGE_ID;
  }

  return config.MOVIE_ANTICIPATION_PAGE_ID;
};

export const formatActorsFromQuery = ({ data = [], fields = {} } = {}) => {
  const formattedCast = map(data, actor => ({
    id: actor[fields.actorId],
    score: `${Math.round(extractValue(actor, fields.votingPercent) * 100)}%`,
    total: `${numeral(actor[fields.votes]).format('0,0')} votes`,
    name: actor[fields.actorName],
    character: actor[fields.characterName],
    image: actor[fields.actorImageUrl]
  }));

  return take(formattedCast, MAX_FAVORITES_COUNT);
};

export const formatAudienceRatings = ({ data = [], fields = {} } = {}) => {
  if (isEmpty(data)) {
    return null;
  }

  return get(data, 0, {});
};

export const getSampleSize = (
  { data = [], fields = {} } = {},
  blocked = false
) => (blocked ? null : get(data, [0, fields.viewers], null));

export const formatCommentsFromQuery = (
  { data = [], fields = {} } = {},
  start,
  end
) => {
  const dataToUse = start && end ? data.splice(start, end) : data;

  const formattedComments = map(dataToUse, comment => {
    return {
      comment_date: comment[fields.commentDate],
      content: comment[fields.commentText],
      nb_likes: comment[fields.likes],
      nb_replies: comment[fields.replies]
    };
  });

  return formattedComments;
};

export default {
  isReleased,
  formatMovie,
  getCurrentTabFromPath,
  formatAudienceRatings,
  getSampleSize,
  getEmotionVotes,
  formatEmotionData
};
